import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "pwa-install-sheet",
  role: "dialog",
  "aria-labelledby": "pwa-install-title"
}
const _hoisted_2 = { class: "pwa-install-brand" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "pwa-install-actions" }
const _hoisted_5 = { class: "pwa-install-brand" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  id: "pwa-install-title",
  class: "pwa-install-title"
}
const _hoisted_8 = { class: "pwa-install-desc" }
const _hoisted_9 = {
  key: 0,
  class: "pwa-install-browser"
}
const _hoisted_10 = {
  key: 1,
  class: "pwa-install-steps"
}
const _hoisted_11 = {
  key: 2,
  class: "pwa-install-afternote"
}
const _hoisted_12 = { class: "pwa-install-actions" }

import { onMounted, onUnmounted } from 'vue'
import iconSrc from '@/assets/images/brand/caion-app-icon.png'
import {
  bootstrapPwaInstall,
  dismissInstallSheet,
  promptInstall,
  teardownPwaInstallTimers,
  usePwaInstall,
} from '@/composables/usePwaInstall'


export default /*@__PURE__*/_defineComponent({
  __name: 'PwaInstallPrompt',
  setup(__props) {

const {
  sheetVisible,
  isInApp,
  fromSms,
  isSmsFlow,
  installGuide,
  showManualSteps,
  canNativePrompt,
  primaryInstallLabel,
  installDone,
} = usePwaInstall()

const onInstall = async () => {
  await promptInstall()
}

onMounted(() => {
  bootstrapPwaInstall()
})

onUnmounted(() => {
  teardownPwaInstallTimers()
})

return (_ctx: any,_cache: any) => {
  return (_unref(sheetVisible))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "pwa-install-mask",
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_unref(dismissInstallSheet) && _unref(dismissInstallSheet)(...args)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_unref(installDone))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("img", {
                    src: _unref(iconSrc),
                    alt: "카이온",
                    class: "pwa-install-icon"
                  }, null, 8, _hoisted_3)
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("h2", {
                  id: "pwa-install-title",
                  class: "pwa-install-title"
                }, "설치가 완료되었습니다", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "pwa-install-desc" }, [
                  _createTextVNode(" 홈 화면에 카이온 앱이 생겼습니다."),
                  _createElementVNode("br"),
                  _createTextVNode(" 이제 "),
                  _createElementVNode("b", null, "브라우저가 아닌 카이온 앱을 열어"),
                  _createTextVNode(" 접속해 주세요."),
                  _createElementVNode("br"),
                  _createTextVNode(" 앱에서 알림을 받을 수 있습니다. ")
                ], -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "app-btn primary pwa-install-ok",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(dismissInstallSheet) && _unref(dismissInstallSheet)(...args)))
                  }, " 확인 ")
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", {
                    src: _unref(iconSrc),
                    alt: "카이온",
                    class: "pwa-install-icon"
                  }, null, 8, _hoisted_6)
                ]),
                _createElementVNode("h2", _hoisted_7, _toDisplayString(_unref(fromSms) || _unref(isSmsFlow) ? '앱을 설치하시겠습니까?' : '앱으로 설치'), 1),
                _createElementVNode("p", _hoisted_8, [
                  (_unref(isInApp))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" 지금 창에서는 설치할 수 없습니다. 아래 버튼으로 브라우저를 연 뒤 설치해 주세요. ")
                      ], 64))
                    : (_unref(fromSms) || _unref(isSmsFlow))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" 문자로 받으신 링크입니다. 카이온 앱으로 설치하면 알림과 바로가기를 편하게 쓸 수 있어요. ")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(" 홈 화면에 카이온을 추가하면 앱처럼 바로 열고 알림도 받을 수 있습니다. ")
                        ], 64))
                ]),
                (_unref(installGuide)?.label)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(installGuide).label), 1))
                  : _createCommentVNode("", true),
                (_unref(showManualSteps) || (!_unref(canNativePrompt) && !_unref(isInApp)))
                  ? (_openBlock(), _createElementBlock("ol", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(installGuide)?.steps || [], (step, i) => {
                        return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(step), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_unref(showManualSteps) || (!_unref(canNativePrompt) && !_unref(isInApp)))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, [...(_cache[5] || (_cache[5] = [
                      _createTextVNode(" 추가가 끝나면 ", -1),
                      _createElementVNode("b", null, "홈 화면의 카이온 앱", -1),
                      _createTextVNode("을 열어 접속해 주세요. ", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "app-btn ghost pwa-install-later",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(dismissInstallSheet) && _unref(dismissInstallSheet)(...args)))
                  }, " 나중에 "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "app-btn primary pwa-install-ok",
                    onClick: onInstall
                  }, _toDisplayString(_unref(primaryInstallLabel)), 1)
                ])
              ], 64))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})